import {
   applyMemberEvents,
   removeInvitationsByUserIds,
   setChannelInfo,
   setUserInfoMap,
   upsertRecentChannelItem,
} from '../../../Slice';
import Store from '../../../Store';
import { getLocalUserDetails } from '../commonActions';
import { fetchInvitationCount } from '../services';

export const handleMemberJoinChannel = (data, event) => {
   try {
      if (!data?.channel || !data?.member) {
         console.warn('Invalid data for member join event:', data);
         return;
      }
      const { channel, member } = data;
      channel.isMember = 1;
      const settings = data?.settings || data.channel.settings;
      const restructured = {
         ...data.channel,
         ...(member && { member }),
         ...(settings && { settings }),
      };

      // Dispatch memberEvent update with JOIN type
      const memberEvents = [
         {
            type: 'JOIN',
            member,
         },
      ];
      if (member.userId === getLocalUserDetails()?.userId) {
         Store.dispatch(setChannelInfo(restructured));
      }
      Store.dispatch(setUserInfoMap(member));
      Store.dispatch(applyMemberEvents({ channelId: restructured?.channelId, memberEvents }));

      // Update recent channel position
      Store.dispatch(
         upsertRecentChannelItem({
            channelId: channel.channelId,
            lastActivityAt: channel.lastActivityAt,
         }),
      );
      const participantIds = member?.userId ? [member.userId] : [];
      if (participantIds.length) {
         Store.dispatch(
            removeInvitationsByUserIds({
               channelId: restructured.channelId,
               userIds: participantIds,
            }),
         );
      }
      fetchInvitationCount();
   } catch (error) {
      console.error('Failed to handle member join channel event:', error);
   }
};
